<template>
  <div>
    <content-header :title="registration.name" :sub-title="''" class="mb-0 "/>
    <el-form ref="form" :model="registration" :rules="rules" label-position="top" v-if="isLoaded">
      <el-row :gutter="60">
        <el-col :span="24"  v-for="q in registration.additionalQs" :key="q._id">
          <!-- Input -->
          <div class="mt-05" v-if="q.type === 1 && checkVisibility(q)">
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-input class="mt-05" v-model="registration.meta[q.metaField]" placeholder="Type here..."/>
            </el-form-item>
          </div>
          <div class="mt-05" v-if="q.type === 2 && checkVisibility(q)">
            <!-- Dropdown -->
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-select class="w-100 mt-05" v-model="registration.meta[q.metaField]" placeholder="Select" clearable :multiple="q.multiDropdownSelect">
                <el-option
                  v-for="({ value }, i) in q.meta.options"
                  :key="value"
                  :label="value"
                  :value="value"
                >
                  {{ value }}
                  <el-dropdown @click.native.stop v-if="q.meta.descriptions && q.meta.descriptions[i].value">
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-alert

                        title="Description"
                        type="info"
                        :closable="false"
                        effect="dark">
                        {{ q.meta.descriptions[i].value }}
                      </el-alert>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="q.isParentQs && q.parentsDependentQsList">
            <el-col :span="24" v-for="c in q.parentsDependentQsList[0].children" :key="c._id">
              <div class="mt-05" v-if="checkChildVisibility(c, q.parentsDependentQsList[0])">
                <!-- Input -->
                <div v-if="c.type === 1">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="'meta.' + camelCase(c.fieldName)">
                    <el-input class="mt-05" v-model="registration.meta[camelCase(c.fieldName)]" placeholder="Type here..."/>
                  </el-form-item>
                </div>

                <!-- Dropdown -->
                <div v-else-if="c.type === 2">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="'meta.' + camelCase(c.fieldName)">
                    <el-select class="w-100 mt-05" v-model="registration.meta[camelCase(c.fieldName)]" placeholder="Select" clearable :multiple="c.multiDropdownSelect">
                      <el-option
                        v-for="({ value }, i) in c.meta.options"
                        :key="value"
                        :label="value"
                        :value="value"
                      >
                        {{ value }}
                        <el-dropdown @click.native.stop v-if="c.meta.descriptions && c.meta.descriptions[i].value">
                          <span class="el-dropdown-link">
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-alert
                              title="Description"
                              type="info"
                              :closable="false"
                              effect="dark">
                              {{ c.meta.descriptions[i].value }}
                            </el-alert>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <!-- File Upload -->
                <div v-else-if="c.type === 3">
                  <el-input-title :required="c.required">{{ c.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
                  <h5 class="mt-05"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
                  <el-upload
                    :headers="uploadHeaders"
                    :accept="accept"
                    :limit="3"
                    :file-list="registration.meta[camelCase(c.fieldName)].map(file => ({ name: file.originalName }))"
                    :before-upload="(file) => beforeUpload(file, c)"
                    :on-error="onError"
                    :on-remove="onRemove"
                    action=""
                    :on-change="(file) => handleChange(file, c)"
                    :auto-upload="false"
                    :on-exceed="onExceed"
                  >
                    <el-button class="mt-0" size="medium" type="secondary">Click to upload</el-button>
                  </el-upload>
                </div>

                <!-- NSWISA PPC Form -->
                <div v-else-if="c.type === 1001">
                  <PPCForm :formItemProp="'meta.' + camelCase(c.fieldName)" v-model="registration.meta[camelCase(c.fieldName)]"/>
                </div>
              </div>
            </el-col>
          </div>
          <div class="mt-05" v-if="q.type === 3 && checkVisibility(q)">
            <!-- File Upload -->
            <el-input-title :required="q.required">{{ q.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
            <h5 class="mt-05"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
            <el-upload

              :headers="uploadHeaders"
              :accept="accept"
              :limit="3"
              :file-list="registration.meta[q.metaField].map(file => ({ name: file.originalName }))"
              :before-upload="(file) => beforeUpload(file, q)"
              :on-error="onError"
              :on-remove="onRemove"
              action=""
              :on-change="(file) => handleChange(file, q)"
              :auto-upload="false"
              :on-exceed="onExceed"
            >
              <el-button class="mt-0" size="medium" type="secondary">Click to upload</el-button>
            </el-upload>
          </div>
          <!------- National Special Types ------>
          <div class="mt-05" v-if="q.type === 1001 && checkVisibility(q)">
            <!-- NSWISA PPC Form -->
            <PPCForm :formItemProp="q.metaField | metaProp" v-model="registration.meta[q.metaField]"/>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash';
import { urlify } from '@/utils/helpers';
import { errormsg } from '@/utils/constants';
import aqsFileUploadMixin from '@/mixins/aqs-file-upload';
import PPCForm from './PPCForm.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };

export default {
  name: 'AdditionalQuestions',
  components: {
    PPCForm
  },
  props: {
    value: Object
  },
  mixins: [aqsFileUploadMixin],
  data() {
    return {
      camelCase: _.camelCase,
      urlify,
      isLoaded: false,
      subTitle: 'The entity requires the following additional information as part of your registration',
      registration: {},
      rules: {},
      isType3: false,
      // camelCase: _.camelCase,
    };
  },
  mounted() {
    this.isLoaded = false;
    this.registration = this.value;
    this.registration.additionalQs.sort((a, b) => a.order - b.order);
    console.log('visibleQuestions', this.visibleQuestions);
    console.log('questions', this.registration.additionalQs);

    // Regitration meta field and validation
    const hasMeta = !!this.registration.meta;
    if (!hasMeta) this.$set(this.registration, 'meta', {});

    _.forEach(this.registration.additionalQs, (q) => {
      const metaField = _.camelCase(q.fieldName);
      // eslint-disable-next-line
      q.metaField = metaField;
      // eslint-disable-next-line
      if (q.required) this.$set(this.rules, `meta.${metaField}`, defaultRequiredRule);
      if (!hasMeta) {
        this.$set(
          this.registration.meta,
          metaField,
          q.type === 3 ? [] : undefined // If it's a file upload initialize an array;
        );
      }
      if (q.isParentQs && q.parentsDependentQsList && q.parentsDependentQsList.length) {
        _.forEach(q.parentsDependentQsList[0].children, (qs) => {
          // eslint-disable-next-line
          qs.metaField = _.camelCase(qs.fieldName);
          this.$set(
            this.registration.meta,
            _.camelCase(qs.fieldName),
            undefined
          );
        });
      }
    });
    this.isLoaded = true;
  },
  methods: {
    updateStep(step) {
      console.log('updating step');

      if (step === 1) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const allRequiredAnswered = this.checkAllRequiredAnswered();
            const verifyUpload = this.verifyUploads(this.isType3);
            console.log('allRequiredAnswered', allRequiredAnswered, 'verifyUpload', verifyUpload);
            if (allRequiredAnswered && verifyUpload) {
              this.$emit('update-step', this.registration, step);
            } else {
              this.$message.error('Please answer all required questions before proceeding.');
            }
          } else {
            this.$message.error('Please answer all required questions before proceeding.');
          }
        });
      } else {
        this.$emit('update-step', this.registration, step);
      }
    },
    checkAllRequiredAnswered() {
      return this.visibleQuestions.every((q) => {
        if (!q.required) return true;
        const answer = this.registration.meta[q.metaField];
        if (q.type === 3) { // File upload
          return Array.isArray(answer) && answer.length > 0;
        }
        if (q.type === 2 && q.multiDropdownSelect) { // Multi-select dropdown
          return Array.isArray(answer) && answer.length > 0;
        }
        return answer !== undefined && answer !== null && answer !== '';
      });
    },
    checkVisibility(q) {
      const check = this.visibleQuestions.some((v) => v._id === q._id);
      if (check) {
        if (q.type === 3) {
          this.isType3 = true;
        }
      } else if (!check) {
        if (q.type === 3) {
          this.registration.meta[q.metaField] = [];
          this.isType3 = false;
        } else {
          this.$set(this.registration.meta, q.metaField, undefined);
        }
      }

      return this.visibleQuestions.some((v) => v._id === q._id && !q.isParentQs);
    },
    checkChildVisibility(question, parentQuestion) {
      console.log(parentQuestion, question);
      const allAnswers = this.registration.meta;
      const childQuestion = this.visibleQuestions.find((qs) => qs._id === parentQuestion._id);
      if (!childQuestion) return false;
      if (!_.includes(parentQuestion.condition, allAnswers[_.camelCase(childQuestion.fieldName)])) return false;
      if (question.level === 2 && childQuestion) {
        const parentAnswer = allAnswers[childQuestion.metaField];
        return _.includes(parentQuestion.condition, parentAnswer);
      }
      const getLastQuestion = parentQuestion.children.find((p) => p.level === question.level - 1);
      if (getLastQuestion) {
        const parentAnswer = allAnswers[_.camelCase(getLastQuestion.fieldName)];
        return _.includes(getLastQuestion.condition, parentAnswer);
      }
      return false;
    }
  },
  filters: {
    metaProp(val) {
      return `meta.${val}`;
    }
  },
  computed: {
    visibleQuestions() {
      const allQuestions = this.registration.additionalQs;
      const allAnswers = this.registration.meta;
      return allQuestions.filter((q) => {
        const { parentsDependentQsList, isParentQs } = q;
        if (!isParentQs) return true;
        const foundParents = allQuestions.find((qs) => qs._id === parentsDependentQsList[0]._id);
        if (!foundParents) return false;
        const parentAnswer = allAnswers[_.camelCase(foundParents.fieldName)];
        return _.includes(parentsDependentQsList[0].condition, parentAnswer);
      });
    },

  },
  watch: {

  }
};
</script>

<style scoped lang="scss">

</style>
